import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";

import type { ServicePage } from "../types";

/**
 * 乾料庫存管理的子頁宣告，四個面向：
 *
 *   乾料儀表   總覽：今日日報狀態、每個廠「日期 × 料號」的結存
 *              狀態、結存趨勢圖與進貨來源組成（見 `DashboardPage.tsx`）
 *   庫存預估   結存預估表，依廠區看從今天起各料號的庫存／進貨／出貨／
 *              結存（見 `ForecastPage.tsx`／`ForecastProjection.tsx`）。
 *   庫存日報   月曆 → 當天總覽 → 日報內容的填寫流程
 *              （見 `DailyReportPage.tsx`）
 *   設定       警示門檻、進貨來源（見 `SettingsPage.tsx`）。
 *
 * 資料都在後端（`/api/v1/aggregate/`，前端的存取集中在 `aggregateApi.ts`）。
 *
 * 權限照後端的 model 權限：儀表與日報看 `view_dailyreport`，設定看
 * `view_healththreshold`。乾料的三個標準角色在建立資料表的 migration
 * 裡就一起拿到這些權限了（`aggregate/0002`），能進這個服務的人原則上
 * 都看得到這三頁；這裡守的是「角色被管理員改過、拿掉某些權限」的情況，
 * 避免點進去才看到一堆 403。
 */
export const aggregatePages: ServicePage[] = [
  {
    path: "dashboard",
    label: "乾料儀表",
    title: "乾料儀表",
    icon: SpaceDashboardOutlinedIcon,
    permissions: ["aggregate.view_dailyreport"],
    load: async () => ({
      Component: (await import("./DashboardPage")).DashboardPage,
    }),
  },
  {
    path: "forecast",
    label: "庫存預估",
    title: "庫存預估",
    icon: InsightsOutlinedIcon,
    permissions: ["aggregate.view_dailyreport"],
    load: async () => ({
      Component: (await import("./ForecastPage")).ForecastPage,
    }),
  },
  {
    path: "daily-report",
    label: "庫存日報",
    title: "庫存日報",
    icon: CalendarMonthOutlinedIcon,
    permissions: ["aggregate.view_dailyreport"],
    // 當天內容（`/daily-report/:plantId/:dateKey`）是獨立網址、可以分享
    // 或加書籤，不是彈窗也不是只存在記憶體裡的畫面狀態——見
    // `DailyReportPage.tsx` 裡的 <Routes>。
    matchNested: true,
    load: async () => ({
      Component: (await import("./DailyReportPage")).DailyReportPage,
    }),
  },
  {
    path: "settings",
    label: "設定",
    title: "設定",
    icon: SettingsOutlinedIcon,
    permissions: ["aggregate.view_healththreshold"],
    load: async () => ({
      Component: (await import("./SettingsPage")).SettingsPage,
    }),
  },
];
